module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row pl-3 mb-3"
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "card mr-0 pb-0"
  }, [(_vm.scope == 'public_b') ? _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("B2B业务数据集\n          ")]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("B2C业务数据集\n          ")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "content pt-1"
  }, [_c('label', [_vm._v("业务类型：")]), _vm._v(" "), _c('el-radio-group', {
    on: {
      "change": _vm.radio_change
    },
    model: {
      value: (_vm.scope),
      callback: function($$v) {
        _vm.scope = $$v
      },
      expression: "scope"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "public_b"
    }
  }, [_vm._v("B2B")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "public_c"
    }
  }, [_vm._v("B2C")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_c('el-button', {
    attrs: {
      "type": "warning",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.go_back()
      }
    }
  }, [_vm._v("返回首页")])], 1)])])]), _vm._v(" "), (_vm.listLoading) ? _c('div', {
    staticClass: "bg-white"
  }, [_vm._m(2)]) : (_vm.pkgList.length == 0) ? _c('div', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.pkgList.length > 0) ? _c('div', {
    staticClass: "row pl-3"
  }, [_c('div', {
    staticClass: "pt-2 pb-2"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": this.page.size,
      "total": this.page.total,
      "current-page": this.page.index + 1
    },
    on: {
      "current-change": _vm.pagechange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row pr-2"
  }, _vm._l((_vm.pkgList), function(item, index) {
    return _c('div', {
      staticClass: "float-left pl-2 pb-2"
    }, [_c('div', {
      staticClass: "dataset-card el-card is-always-shadow card-body"
    }, [_c('div', {
      staticClass: "image-container",
      on: {
        "click": function($event) {
          return _vm.show_item_detail(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageUrl(item),
        "alt": "主图"
      }
    })]), _vm._v(" "), _c('h6', {
      staticClass: "cursor-pointer pt-3",
      on: {
        "click": function($event) {
          return _vm.show_item_detail(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.remark) ? _c('p', {
      staticClass: "card-text"
    }, [_vm._v("\n          " + _vm._s(item.remark.length > 20 ? item.remark.substring(0, 20) + " ..." : item.remark))]) : _c('p', {
      staticClass: "card-text"
    }, [_vm._v("通过AI模型从大数据平台挖掘生成该数据集")]), _vm._v(" "), _c('div', {
      staticClass: "mb-2"
    }, [_c('el-tag', {
      attrs: {
        "type": "primary",
        "effect": "dark",
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "el-icon-office-building"
    }), _vm._v(" " + _vm._s(Math.round(item.entCount / 10000) + '万') + "\n          ")]), _vm._v(" "), _c('el-tag', {
      attrs: {
        "type": "success",
        "effect": "dark",
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "el-icon-s-custom"
    }), _vm._v(" " + _vm._s(Math.round(item.humCount / 10000) + '万') + "\n          ")])], 1), _vm._v(" "), _c('div', [_c('el-button', {
      attrs: {
        "type": "",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.show_item_detail(item)
        }
      }
    }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.show_export(item)
        }
      }
    }, [_vm._v("下载")])], 1)])])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "数据集",
      "visible": _vm.dlg_pkg_use,
      "width": "96%",
      "close-on-click-modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_pkg_use = $event
      }
    }
  }, _vm._l((this.sltPkg.folderList), function(item, index) {
    return _c('div', {
      staticClass: "pb-3"
    }, [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n        ")]), _vm._v(" "), _c('div', [_c('div', [_vm._v(_vm._s(item.remark) + "\n        ")]), _vm._v(" "), (item.entCount > 0) ? _c('span', [_vm._v("企业数量："), _c('font', {
      attrs: {
        "color": "orange"
      }
    }, [_vm._v(_vm._s(item.entCount.toLocaleString()))]), _vm._v("家，")], 1) : _vm._e(), _vm._v(" "), (item.humCount > 0) ? _c('span', [_vm._v("人群数量："), _c('font', {
      attrs: {
        "color": "orange"
      }
    }, [_vm._v(_vm._s(item.humCount.toLocaleString()))]), _vm._v("人，")], 1) : _vm._e(), _vm._v(" "), (item.md5Count > 0) ? _c('span', [_vm._v("MD5数据："), _c('font', {
      attrs: {
        "color": "orange"
      }
    }, [_vm._v(_vm._s(item.md5Count.toLocaleString()))]), _vm._v("条")], 1) : _vm._e()])])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出",
      "visible": _vm.dlg_export_model,
      "width": "96%",
      "close-on-click-modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_export_model = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "50px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    attrs: {
      "placeholder": "请输入接收数据的邮箱"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticClass: "item_w",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "筛选"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), (_vm.form.delivery) ? _c('el-form-item', {
    attrs: {
      "label": "地区"
    }
  }, [_c('el-select', {
    staticClass: "item_w",
    attrs: {
      "placeholder": "请选择省份",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getProv($event)
      }
    },
    model: {
      value: (_vm.form.adProvs),
      callback: function($$v) {
        _vm.$set(_vm.form, "adProvs", $$v)
      },
      expression: "form.adProvs"
    }
  }, _vm._l((_vm.provs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.delivery) ? _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-date-picker', {
    staticClass: "item_w",
    attrs: {
      "type": "monthrange",
      "align": "left",
      "start-placeholder": "开始",
      "end-placeholder": "结束",
      "picker-options": _vm.birthOptions
    },
    model: {
      value: (_vm.form.date_range),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_range", $$v)
      },
      expression: "form.date_range"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.delivery) ? _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "male"
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_vm._v("男性")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "female"
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_vm._v("女性")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": ""
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_vm._v("不限")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("立即提交")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dlg_share = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('label', [_vm._v("规模庞大的高商业价值的B2B业务数据集，覆盖多种应用场景，可上传到广告平台实现精准投放，开箱即用。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('label', [_vm._v("覆盖B2C业务多种应用场景，可上传到广告平台实现精准投放，开箱即用。支持个性化定制，支持批量下载。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-420"
  }, [_c('div', {
    staticClass: "loading_position"
  }, [_c('i', {
    staticClass: "el-icon-loading",
    staticStyle: {
      "font-size": "25px",
      "margin-left": "10px",
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-block"
  }, [_vm._v("加载中...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-435"
  }, [_c('div', {
    staticClass: "loading_position"
  }, [_c('span', {
    staticClass: "d-block"
  }, [_vm._v("无数据，请重试")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268f2dd9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/Pkg.vue
// module id = 267
// module chunks = 1